import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.transferProduct.title, 'Transfer product'),
  serialNumber: () => __(translations.transferProduct.serialNumber, 'Serial number'),
  subLocation: () => __(translations.transferProduct.subLocation, 'Sub-location'),
};
